import { Link } from 'react-router-dom';

export interface CourseItem {
  id: number;
  title: string;
  category: string;
  doctor: string;
  lessons: number;
  price: number;
  image: string;
}

interface CourseCardProps {
  course: CourseItem;
  onBuy: (course: CourseItem) => void;
}

export default function CourseCard({ course, onBuy }: CourseCardProps) {
  return (
    <article className="group relative flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
      <Link
        to={`/courses/${course.id}`}
        className="absolute inset-0 z-10"
        aria-label={`查看课程详情：${course.title}`}
      ></Link>
      <div className="relative w-full h-[190px] overflow-hidden">
        <img
          src={course.image}
          alt={course.title}
          title={`${course.title} - 精品课程`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur text-xs font-medium text-primary-700">
          {course.category}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-5">
        <h3 className="font-heading font-semibold text-foreground-900 leading-snug text-balance mb-4 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {course.title}
        </h3>
        <div className="mt-auto">
          <div className="flex items-center justify-between text-xs text-foreground-500">
            {course.doctor && (
              <span className="inline-flex items-center gap-1.5">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-user-line"></i>
                </span>
                {course.doctor}
              </span>
            )}
            <span className={`inline-flex items-center gap-1${course.doctor ? '' : ' ml-auto'}`}>
              <i className="ri-play-list-line"></i>
              {course.lessons} 课时
            </span>
          </div>

          <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
            {course.price > 0 ? (
              <>
                <span className="flex items-baseline gap-0.5 font-heading font-bold text-primary-600">
                  <span className="text-sm">¥</span>
                  <span className="text-xl">{course.price}</span>
                </span>
                <button
                  type="button"
                  onClick={() => onBuy(course)}
                  className="relative z-20 inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-shopping-bag-3-line"></i>
                  立即购买
                </button>
              </>
            ) : (
              <span className="font-heading font-bold text-primary-600 text-xl">免费</span>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}